import { useEffect } from "react";
import CallNowPopup from "@/components/landing/CallNowPopup";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ServicesGrid from "@/components/landing/ServicesGrid";
import WhyUs from "@/components/landing/WhyUs";
import Testimonials from "@/components/landing/Testimonials";
import Gallery from "@/components/landing/Gallery";
import ServiceArea from "@/components/landing/ServiceArea";
import PromoFinancing from "@/components/landing/PromoFinancing";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import { Phone } from "lucide-react";
import { COMPANY, FAQS } from "@/data/site";
import { setSeo, buildLocalBusinessSchema, buildFaqSchema } from "@/lib/seo";

export default function LandingPage() {
  useEffect(() => {
    setSeo({
      title: `${COMPANY.name} — Plumbing, Drain & Sewer Service · Roseville, MI`,
      description:
        "Peak Plumbing — Macomb & Oakland County's family-owned drain, sewer & plumbing team. Same-day appointments, upfront pricing, honest service. Call (586) 351-6271.",
      path: "/",
      jsonLd: [
        { id: "org", data: buildLocalBusinessSchema() },
        { id: "faq", data: buildFaqSchema(FAQS) },
      ],
    });
  }, []);

  return (
    <main data-testid="landing-page" className="bg-white">
      <Navbar />
      <Hero />
      <ServicesGrid />
      <WhyUs />
      <Testimonials />
      <Gallery />
      <ServiceArea />
      <PromoFinancing />
      <FAQ />
      <Footer />

      {/* Floating mobile call button */}
      <a
        data-testid="floating-call-button"
        href={`tel:${COMPANY.phoneTel}`}
        className="md:hidden fixed bottom-5 right-5 z-30 btn-cta inline-flex items-center gap-2 px-4 py-3 text-sm shadow-2xl"
      >
        <Phone size={16} /> Call Now
      </a>

      <CallNowPopup />
    </main>
  );
}
